import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Book, Mail, Lock, ArrowRight } from 'lucide-react';
import AuthService from './AuthService';
import { Card } from '../components/Card';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/Button';
import { Input } from '../components/Input';

export const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth(); // ADD THIS - use context login
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await login(email, password, remember); // CHANGE THIS - use context login instead of AuthService.login
      
      // Navigate based on user role
      if (response.user.role === 'grandparent') {
        navigate('/grandparent-dashboard');
      } else {
        navigate('/parent-dashboard');
      }
    } catch (err) {
      setError(err.message || 'Failed to login');
      setLoading(false);
    }
  };
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #faf5ff 0%, #fce7f3 50%, #dbeafe 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div style={{ width: '100%', maxWidth: '28rem' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
            <Book style={{ width: '2.5rem', height: '2.5rem', color: '#9333ea' }} />
            <span style={{ 
                fontSize: '2.5rem',
                fontWeight: '900',
                fontFamily: '"Comic Sans MS", "Chalkboard SE", "Comic Neue", cursive, sans-serif',
                display: 'flex', 
                gap: '0.1rem',
                letterSpacing: '0.05rem'
              }}>
                <span style={{ 
                  color: '#ff4757',
                  WebkitTextStroke: '3px black',
                  paintOrder: 'stroke fill',
                  textShadow: '3px 3px 0px rgba(0,0,0,0.2)'
                }}>R</span>
                <span style={{ 
                  color: '#ff6b35',
                  WebkitTextStroke: '3px black',
                  paintOrder: 'stroke fill',
                  textShadow: '3px 3px 0px rgba(0,0,0,0.2)'
                }}>e</span>
                <span style={{ 
                  color: '#ffd93d',
                  WebkitTextStroke: '3px black',
                  paintOrder: 'stroke fill',
                  textShadow: '3px 3px 0px rgba(0,0,0,0.2)'
                }}>a</span>
                <span style={{ 
                  color: '#a855f7',
                  WebkitTextStroke: '3px black',
                  paintOrder: 'stroke fill',
                  textShadow: '3px 3px 0px rgba(0,0,0,0.2)'
                }}>d</span>
                <span style={{ 
                  color: '#ffd93d',
                  WebkitTextStroke: '3px black',
                  paintOrder: 'stroke fill',
                  textShadow: '3px 3px 0px rgba(0,0,0,0.2)'
                }}>2</span>
                <span style={{ 
                  color: '#06b6d4',
                  WebkitTextStroke: '3px black',
                  paintOrder: 'stroke fill',
                  textShadow: '3px 3px 0px rgba(0,0,0,0.2)'
                }}>M</span>
                <span style={{ 
                  color: '#3b82f6',
                  WebkitTextStroke: '3px black',
                  paintOrder: 'stroke fill',
                  textShadow: '3px 3px 0px rgba(0,0,0,0.2)'
                }}>e</span>
              </span>
          </div>
          <h1 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '0.5rem' }}>Welcome Back!</h1>
          <p style={{ color: '#6b7280', fontSize: '1rem' }}>Sign in to continue sharing stories</p>
        </div>

        <Card style={{ padding: '2rem' }}>
          {error && (
            <div style={{ 
              padding: '0.75rem', 
              background: '#fee2e2', 
              color: '#991b1b', 
              borderRadius: '0.5rem', 
              marginBottom: '1rem',
              fontSize: '0.875rem'
            }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151', fontSize: '0.875rem' }}>Email</label>
              <Input 
                icon={Mail}
                type="email" 
                placeholder="grandma@example.com" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151', fontSize: '0.875rem' }}>Password</label>
              <Input 
                icon={Lock}
                type="password" 
                placeholder="••••••••" 
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontSize: '0.875rem', color: '#4b5563' }}>
                <input 
                  type="checkbox" 
                  checked={remember}
                  onChange={(e) => setRemember(e.target.checked)}
                  style={{ cursor: 'pointer' }} 
                />
                Remember me
              </label>
              <Link to="/forgot-password" style={{ color: '#9333ea', fontSize: '0.875rem', textDecoration: 'none', fontWeight: '600' }}>
                Forgot password?
              </Link>
            </div>

            <Button type="submit" variant="primary" style={{ width: '100%', justifyContent: 'center', padding: '1rem' }} disabled={loading}>
              {loading ? 'Signing In...' : 'Sign In'}
              <ArrowRight style={{ width: '1.25rem', height: '1.25rem' }} />
            </Button>
          </form>

          <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
            <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>
              Don't have an account?{' '}
              <button 
                onClick={() => navigate('/signup')}
                style={{ color: '#9333ea', fontWeight: '600', background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.875rem', textDecoration: 'underline' }}
              >
                Sign up
              </button>
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
};